// PatientFlagsControllerApi  getPatientFlagById

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientFlagsControllerApi } from "../../../services";
import { getConfigObject } from "../../../utils/utils";

interface Props {
  patientFlagId: string;
  xTENANTID: string;
}

/**
 *
 * @author [Atish Bagate]
 *
 */
export const useGetPatientFlagById = ({ patientFlagId, xTENANTID }: Props): any => {  
  return useQuery({
    queryKey: ["patient-flag-by-id", patientFlagId, xTENANTID],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
      enabled: !!patientFlagId && !!xTENANTID,
    queryFn: async () =>
      await new PatientFlagsControllerApi(getConfigObject())
        .getPatientFlagById(patientFlagId, xTENANTID)
        .then((res) => res?.data),
  });
};
